import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/global.css";
import "../styles/layout.css";
import LongLogo from "../assets/MILO_WideLogo.png"; // Import the image

function Navbar({ user, onLogin, onLogout }) {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 950);
    const [menuOpen, setMenuOpen] = useState(false);
	
	useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 950);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    
	return (
        <header>
            <nav className="navbar">
                <a href="/">
					<img src={LongLogo} alt="MILO Homes" className="navbar-logo" />
				</a>
				
				{/* Show hamburger menu on mobile */}
                {isMobile ? (
                    <>
                        {/* Hamburger Menu Button */}
                        <div className="menu-icon" onClick={() => setMenuOpen(true)}>☰</div>

                        {/* Mobile Menu (with slide-down effect) */}
                        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
                            <button className="close-menu" onClick={() => setMenuOpen(false)}>✖</button>
                            <div className="menu-links">
                                <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
                                <Link to="/why-MILO" onClick={() => setMenuOpen(false)}>Why MILO</Link>
									{/*<Link to="/Demo" onClick={() => setMenuOpen(false)}>MILO Demo</Link>*/}
								<Link to="/waitlist" className="waitlist-button" onClick={() => setMenuOpen(false)}>Join Waitlist</Link>
									{/*{user ? (
                                    <button onClick={onLogout} className="logout-button">Logout</button>
                                ) : (
                                    <button onClick={onLogin} className="login-button">Login</button>
									)}*/}
                            </div>
                        </div>
                    </>
                ) : (
					<div className="desktop-nav">
                        <div className="nav-links">
							<Link to="/about" className="nav-item">
							  <p>About Us</p>
							</Link>

							<Link to="/why-MILO">
								<div className="nav-item">
									<p>Why MILO</p>
								</div>
							</Link>
							{/*<Link to="/Demo">
								<div className="nav-item">
									<Link to="/Demo">MILO Demo</Link>
								</div>
							</Link>*/}
							<Link to="/waitlist">
								<div className="nav-item">
									<p className="waitlist-button">Join Waitlist</p>
								</div>
							</Link>
                        </div>
                        {/*<div id="user-controls" className="user-controls">
                            {user ? (
                                <div className="user-info">
                                    <span className="username">Welcome, {user.username}!</span>
                                    <button onClick={onLogout} className="logout-button">Logout</button>
                                </div>
                            ) : (
                                <button onClick={onLogin} className="login-button">Login</button>
                            )}
                        </div>*/}
						<div className="user-controls">
							<Link
								to={user ? "/profile" : "/explore"}
								className="alpha-button"
							>
								MILO Alpha
							</Link>
						</div>
                    </div>
				)}
            </nav>
        </header>
    );
}

export default Navbar;